import {Application} from "@hotwired/stimulus"
import PasswordVisibility from 'stimulus-password-visibility'
import Notification from 'stimulus-notification'
import TextareaAutogrow from 'stimulus-textarea-autogrow'
import Popover from '@stimulus-components/popover'

const application = Application.start()
application.register('password-visibility', PasswordVisibility)
application.register('notification', Notification)
application.register('textarea-autogrow', TextareaAutogrow)
application.register('popover', Popover)
// Configure Stimulus development experience
application.debug = false
window.Stimulus = application
export {application}
